// src/components/Common/AppFooter.js
import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { Link } from 'react-router-dom';

const AppFooter = () => {
  return (
    <footer className="bg-white border-top py-4 mt-auto">
      <Container fluid>
        <Row className="align-items-center">
          <Col md={6} className="text-center text-md-start text-muted small">
            © {new Date().getFullYear()} BrahmaGPT. AI drafts content — Humans review, edit, and approve. BrahmaGPT is an AI and can make mistakes.
          </Col>
          <Col md={6} className="text-center text-md-end mt-2 mt-md-0">
          <div className="d-flex align-items-center justify-content-center justify-content-md-end gap-3 flex-wrap">
          <Link to="/terms" className="text-muted text-decoration-none small">Terms of Use</Link>
          <Link to="/privacy" className="text-muted text-decoration-none small">Privacy Policy</Link>
          <Link to="/ai-ethics-policy" className="text-muted text-decoration-none small">AI Ethics Policy</Link>
          <Link to="/dpa" className="text-muted text-decoration-none small">DPA</Link>
          <Link to="/security-compliance" className="text-muted text-decoration-none small">Security Compliance</Link>
        </div>
          </Col>
        </Row>
      </Container>
    </footer>
  );
};

export default AppFooter;
